module.exports = __webpack_public_path__ + "static/media/qsp.5e19d4d6.svg";